import { Redux } from 'types/local'
import { createActionsSet } from 'utils/redux'
import { createApiHandler } from 'helpers/apiHandler'
import chatApis from 'api/chat'
import dayjs from 'dayjs'
import appLoadingFeatureActions from './app-loading.actions'

const types = {
  CREATE_CHAT_MESSAGE: createActionsSet.api('chat-feature.create-message-chat'),
  GET_CHAT_MESSAGE: createActionsSet.api('chat-feature.get-message-chat'),
  RECEIVED_MESSSAGE: 'chat-feature.received-messsage',
}

const createMessagesChat =
  ({ message }: { message: string }) =>
  async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({ type: types.CREATE_CHAT_MESSAGE.REQUEST })
    // dispatch(appLoadingFeatureActions.start())
    try {
      const handleApi = createApiHandler(dispatch, getState)
      const response = await handleApi(chatApis.createMessageChat({ message }))
      dispatch({ type: types.CREATE_CHAT_MESSAGE.SUCCESS, payload: response.data })
    } catch (e) {
      // dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.CREATE_CHAT_MESSAGE.FAILED, payload: e })
    } finally {
      // dispatch(appLoadingFeatureActions.finish())
    }
  }

const getMessagesChat = (pageSize: number) => async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
  dispatch({ type: types.GET_CHAT_MESSAGE.REQUEST })
  // dispatch(appLoadingFeatureActions.start())
  try {
    const handleApi = createApiHandler(dispatch, getState)
    const response = await handleApi(chatApis.getChatList({ per_page: pageSize }))
    dispatch({
      type: types.GET_CHAT_MESSAGE.SUCCESS,
      payload: {
        data: response.messages,
        per_page: pageSize,
        total: response.meta.total,
      },
    })
  } catch (e) {
    // dispatch(appLoadingFeatureActions.finish())
    dispatch({ type: types.GET_CHAT_MESSAGE.FAILED, payload: e })
  } finally {
    // dispatch(appLoadingFeatureActions.finish())
  }
}

export const chatActions = {
  types,
  createMessagesChat,
  getMessagesChat,
}
